import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const money = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const inputCls = "w-full px-3 py-2 rounded-md bg-black border border-white/15 text-white text-sm outline-none focus:border-[#F2B705]/60 [color-scheme:dark]";
export const labelCls = "text-[11px] uppercase tracking-wider text-white/45 block mb-1";

export const authHeaders = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export async function uploadFinanceFile(token, file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(`${API}/finance/upload`, fd, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
  return data;
}

export function Modal({ title, onClose, children, wide = false }) {
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/75 backdrop-blur-sm overflow-y-auto py-10 px-4" onClick={onClose}>
      <div className={`w-full ${wide ? "max-w-3xl" : "max-w-xl"} bg-[#0C0C0C] border border-white/15 rounded-xl shadow-2xl`} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
          <h3 className="text-white font-bold">{title}</h3>
          <button data-testid="modal-close-btn" onClick={onClose} className="text-white/40 hover:text-white text-xl leading-none">×</button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}

export function VoidDialog({ label, onConfirm, onClose, busy }) {
  return (
    <Modal title={`Void ${label}`} onClose={onClose}>
      <p className="text-white/60 text-sm mb-3">Voided records stay in the audit log forever. A reason is required.</p>
      <VoidForm onConfirm={onConfirm} busy={busy} />
    </Modal>
  );
}

function VoidForm({ onConfirm, busy }) {
  const submit = (e) => {
    e.preventDefault();
    const reason = e.target.reason.value.trim();
    if (reason) onConfirm(reason);
  };
  return (
    <form onSubmit={submit}>
      <textarea name="reason" data-testid="void-reason-input" required placeholder="Reason for voiding (required)" rows={3} className={inputCls} />
      <button type="submit" data-testid="void-confirm-btn" disabled={busy}
        className="mt-3 px-4 py-2 rounded-md bg-red-500/90 hover:bg-red-500 text-white text-sm font-bold disabled:opacity-60">
        {busy ? "Voiding…" : "Void Permanently"}
      </button>
    </form>
  );
}
